"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AerodromeProvider = void 0;
const bignumber_1 = require("@ethersproject/bignumber");
const chain_1 = require("@zenlink-interface/chain");
const router_config_1 = require("@zenlink-interface/router-config");
const abis_1 = require("../abis");
const entities_1 = require("../entities");
const util_1 = require("../util");
const LiquidityProvider_1 = require("./LiquidityProvider");
class AerodromeProvider extends LiquidityProvider_1.LiquidityProvider {
    constructor(chainId, client) {
        super(chainId, client);
        this.poolCodes = [];
        this.stateMultiCall = {
            [chain_1.ParachainId.BASE]: '0xAFCCA0f68e0883b797c71525377DE46B2E65AB28',
        };
        this.factory = {
            [chain_1.ParachainId.BASE]: '0x420DD381b31aEf6683db6B902084cB0FFECe40Da',
        };
    }
    async getPools(tokens) {
        if (!(this.chainId in this.stateMultiCall)) {
            this.lastUpdateBlock = -1;
            return;
        }
        // tokens deduplication
        const tokenMap = new Map();
        tokens.forEach(t => tokenMap.set((0, util_1.formatAddress)(t.address), t));
        const tokensDedup = Array.from(tokenMap.values());
        // tokens sorting
        const tok0 = tokensDedup.map(t => [(0, util_1.formatAddress)(t.address), t]);
        tokens = tok0.sort((a, b) => (b[0] > a[0] ? -1 : 1)).map(([_, t]) => t);
        const pools = [];
        for (let i = 0; i < tokens.length; ++i) {
            const t0 = tokens[i];
            for (let j = i + 1; j < tokens.length; ++j) {
                const t1 = tokens[j];
                pools.push([t0, t1]);
            }
        }
        const poolState = await this.client.multicall({
            allowFailure: true,
            contracts: pools.map(pool => ({
                args: [
                    this.factory[this.chainId],
                    pool[0].address,
                    pool[1].address,
                ],
                address: this.stateMultiCall[this.chainId],
                chainId: chain_1.chainsParachainIdToChainId[this.chainId],
                abi: abis_1.velodromeV2StateMulticall,
                functionName: 'getFullState',
            })),
        }).catch((e) => {
            console.warn(e.message);
            return undefined;
        });
        poolState?.forEach((states, i) => {
            if (states.status !== 'success' || !states.result)
                return;
            states.result.forEach((state) => {
                const reserve0 = bignumber_1.BigNumber.from(state.reserve0);
                const reserve1 = bignumber_1.BigNumber.from(state.reserve1);
                const swapFee = Number(state.swapFee) / 1e4;
                const solidlyPool = new entities_1.SolidlyPool(state.pool, pools[i][0], pools[i][1], swapFee, reserve0, reserve1, state.isStable);
                const pc = new entities_1.VelodromeV2PoolCode(solidlyPool, this.getPoolProviderName());
                this.poolCodes.push(pc);
                ++this.stateId;
            });
        });
    }
    _getProspectiveTokens(t0, t1) {
        const set = new Set([
            t0,
            t1,
            ...router_config_1.BASES_TO_CHECK_TRADES_AGAINST[this.chainId],
            ...(router_config_1.ADDITIONAL_BASES[this.chainId]?.[t0.address] || []),
            ...(router_config_1.ADDITIONAL_BASES[this.chainId]?.[t1.address] || []),
        ]);
        return Array.from(set);
    }
    startFetchPoolsData() {
        this.stopFetchPoolsData();
        this.poolCodes = [];
        this.getPools(router_config_1.BASES_TO_CHECK_TRADES_AGAINST[this.chainId]); // starting the process
        this.unwatchBlockNumber = this.client.watchBlockNumber({
            onBlockNumber: (blockNumber) => {
                this.lastUpdateBlock = Number(blockNumber);
            },
            onError: (error) => {
                console.error(error.message);
            },
        });
    }
    async fetchPoolsForToken(t0, t1) {
        await this.getPools(this._getProspectiveTokens(t0, t1));
    }
    getCurrentPoolList() {
        return this.poolCodes;
    }
    stopFetchPoolsData() {
        if (this.unwatchBlockNumber)
            this.unwatchBlockNumber();
    }
    getType() {
        return LiquidityProvider_1.LiquidityProviders.Aerodrome;
    }
    getPoolProviderName() {
        return 'Aerodrome';
    }
}
exports.AerodromeProvider = AerodromeProvider;
